const tableHeadList: any[] = [
  {
    headTitle: "契約者（法人）名",
    align: "center",
  },
  {
    headTitle: "氏名",
    align: "center",
  },
  {
    headTitle: "退職届状況",
    align: "center",
  },
  {
    headTitle: "退職日",
    align: "center",
  },
  {
    headTitle: "退職理由",
    align: "center",
  },
  {
    bottom: [
      {
        headTitle: "合算／請求",
      },

      {
        headTitle: "退職情報登録",
      },
    ],
    top: {
      headTitle: "退職者申請",
    },
  },
  {
    headTitle: "退職手当金額",
    align: "center",
  },
  {
    headTitle: "非居住",
    align: "center",
  },
  {
    headTitle: "状況",
    align: "center",
  },
  {
    headTitle: "時効",
    align: "center",
  },
];

const retireApllyFlg = {
  "00": "未申請",
  "01": "受理待ち",
  "02": "再受理待ち",
  "03": "稟議・決裁結果待ち",
  "04": "課長代理確認待ち",
  "06": "上長承認待ち",
  "08": "承認済",
  "10": "契約者差戻中",
  "11": "承認済",
  "13": "承認済",
  "15": "取下げ済",
  "17": "添付待ち",
};

export { tableHeadList, retireApllyFlg };
